import { Heading, Text } from '@rtkwlf/c3-core-react';
import './widget-error.css';
import { Button } from '@rtkwlf/fenrir-react';

type WidgetErrorComponentProps = React.ComponentPropsWithoutRef<'div'>;

type WidgetErrorProps = {
  /**
   * icon for action button
   */
  actionIcon: React.ReactNode;

  /**
   * intl string of action text
   */
  actionText: string;

  /**
   * rendered html attributes of div
   *
   * @default undefined
   */
  attributes?: WidgetErrorComponentProps;

  /**
   * component className
   *
   * @default undefined
   */
  className?: string;

  /**
   * description of the widget. Falls below the heading
   */
  description: React.ReactNode;

  /**
   *  heading of the widget. Falls below the icon
   */
  heading: React.ReactNode;

  /**
   * title of the widget
   */
  icon: React.ReactNode;

  /**
   * callback when user clicks retry button
   */
  onActionClick: (e: React.MouseEvent) => void;
};

const WidgetError: React.FunctionComponent<WidgetErrorProps> = ({
  actionIcon,
  actionText,
  attributes,
  className,
  description,
  heading,
  icon,
  onActionClick,
  ...rest
}) => {
  return (
    <div {...attributes} {...rest} c3-widget-error="" className={className}>
      {icon}
      <Heading as="h3" align="center" size="3">
        {heading}
      </Heading>
      <Text as="div" align="center" contrast="medium" size="2">
        {description}
      </Text>
      <Button variant="tertiary" iconLeft={actionIcon} onClick={onActionClick}>
        {actionText}
      </Button>
    </div>
  );
};

WidgetError.displayName = 'WidgetError';

export { WidgetError };
export type { WidgetErrorProps };
